/**
 * @author Michael Hasenstein <hasenstein@yahoo.com>
 * @copyright REFINIO GmbH 2017
 * @license CC-BY-NC-SA-2.5; portions MIT License
 * @version 0.0.1
 */
import { STORAGE } from '../storage-base-common.js';
import { ensurePlatformLoaded } from './platform.js';
function getSBDF() {
    const sbdf = globalThis.__ONE_CORE_STORAGE_SBDF__;
    if (!sbdf) {
        throw new Error('SBDF not initialized - platform not loaded');
    }
    return sbdf;
}
export function setPlatformForSbdf(exports) {
    globalThis.__ONE_CORE_STORAGE_SBDF__ = exports;
}
/**
 * This method removes an entry from storage. If the key does not exist, nothing happens, no
 * error is thrown.
 *
 * **Note:** There will be no error if the file to be deleted does not exist to begin with.
 * @static
 * @async
 * @param {string} filename - The filename to be deleted
 * @param {StorageDirTypes} [type='objects']
 * @returns {Promise<undefined>} Returns a promise that resolves with `undefined`.
 * @throws {Error} Throws an `Error` if no filename is given
 */
export function deleteFile(filename, type = STORAGE.OBJECTS) {
    ensurePlatformLoaded();
    return getSBDF().deleteFile(filename, type);
}
//# sourceMappingURL=storage-base-delete-file.js.map